import React, { useState } from "react";
import Slider from "@material-ui/core/Slider";
import { makeStyles } from "@material-ui/core/styles";

function CompaniesFilter(props) {
  const { filters, setFilters, fetchCompanyList } = props;

  const handleChange = (event, newValue) => {
    setFilters({ ...filters, range: newValue });
  };

  const handleFilter = () => {
    fetchCompanyList("filter");
    document.getElementById("close-filter").click();
  };
  return (
    <>
      <div
        className="modal fade pb-m-80 mt-m-80"
        id="change-filter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="change-filter-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
                id="close-filter"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
              <div className="modal-body p-0">
                <h5 className="text-center" id="change-filter-title">
                  Filter
                </h5>
                <div className="form-box pt-20">
                  <form>
                    <div className="form-group">
                      <label
                        htmlFor="price-buttons"
                        className="overline dark-grey-color"
                      >
                        Price Sorting
                      </label>
                      <div className="price-buttons mb-3">
                        <a
                          onClick={() => setFilters({ ...filters, price: "" })}
                          className={
                            filters.price === ""
                              ? "custom-btn-small custom-button-extra-small filter-button active"
                              : "custom-btn-small custom-button-extra-small filter-button"
                          }
                        >
                          No sorting
                        </a>
                        <a
                          onClick={() =>
                            setFilters({ ...filters, price: "min" })
                          }
                          className={
                            filters.price === "min"
                              ? "custom-btn-small custom-button-extra-small filter-button active"
                              : "custom-btn-small custom-button-extra-small filter-button"
                          }
                        >
                          Min Price
                        </a>
                        <a
                          onClick={() =>
                            setFilters({ ...filters, price: "max" })
                          }
                          className={
                            filters.price === "max"
                              ? "custom-btn-small custom-button-extra-small filter-button active"
                              : "custom-btn-small custom-button-extra-small filter-button"
                          }
                        >
                          Max Price
                        </a>
                        <div className="clearfix"></div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-sm-12">
                          <label
                            htmlFor="near-zipcode pb-2"
                            className="overline dark-grey-color"
                          >
                            Completed moves
                          </label>
                          <div id="slider-range" className="mt-0">
                            <Slider
                              value={filters.range}
                              onChange={handleChange}
                              valueLabelDisplay="auto"
                              aria-labelledby="range-slider"
                            />
                            <div className="col-12 caption dark-grey-color">
                              <span id="slider-range-value1">
                                {filters.range[0]}
                              </span>
                              -
                              <span id="slider-range-value2">
                                {filters.range[1]}
                              </span>{" "}
                              moves
                            </div>
                          </div>

                          <div className="row slider-labels pt-3"></div>

                          <div className="row">
                            <div className="col-sm-12">
                              <form>
                                <input
                                  type="hidden"
                                  name="min-value"
                                  value=""
                                />
                                <input
                                  type="hidden"
                                  name="max-value"
                                  value=""
                                />
                              </form>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-sm-6">
                          <label className="dark-grey-color mt-2 custom-checkbox-wrapper">
                            <input
                              type="checkbox"
                              name="storage"
                              checked={filters.top_ratted}
                              onChange={() =>
                                setFilters({
                                  ...filters,
                                  top_ratted: !filters.top_ratted,
                                })
                              }
                            />
                            <span className="caption dark-grey-color schedule-checkbox">
                              Top rated
                            </span>
                            <span className="custom-check-box"></span>
                          </label>{" "}
                        </div>
                      </div>
                    </div>

                    <div className="form-group pt-3">
                      <div className="row justify-content-center">
                        <div className="col-12 col-sm-10">
                          <button
                            type="button"
                            onClick={handleFilter}
                            className="red-btn custom-buton custom-buton-large w-100"
                          >
                            Use Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompaniesFilter;
